<h2 mat-dialog-title>Enviar contrato por WhatsApp</h2>

<div mat-dialog-content fxLayout="column" fxLayoutGap="16px">
    <p class="subtitle">Selecione para quem deseja enviar o link do contrato
        (cada destinatário receberá a mensagem individualmente)</p>

    <div class="actions-row" fxLayout="row" fxLayoutAlign="end center"
        fxLayoutGap="8px">
        <button mat-button color="primary" (click)="selectAll()">
            <mat-icon>select_all</mat-icon> Selecionar Todos
        </button>
        <button mat-button (click)="clearAll()">
            <mat-icon>clear_all</mat-icon> Limpar Seleção
        </button>
    </div>

    <div class="recipients-list" fxLayout="column" fxLayoutGap="12px">
        <mat-card *ngFor="let recipient of data.recipients"
            class="recipient-card"
            [class.selected]="isSelected(recipient.id)"
            (click)="toggleRecipient(recipient.id)">
            <mat-card-content fxLayout="row"
                fxLayoutAlign="space-between center">
                <div fxLayout="column" fxLayoutGap="4px">
                    <div class="recipient-name">{{ recipient.name }}</div>
                    <div class="recipient-role">{{ recipient.role }}</div>
                    <div class="recipient-phone" fxLayout="row"
                        fxLayoutAlign="start center" fxLayoutGap="8px">
                        <mat-icon>phone</mat-icon>
                        <span>{{ recipient.phone }}</span>
                    </div>
                    <div class="recipient-phone"
                        *ngIf="recipient.whatsAppNumber" fxLayout="row"
                        fxLayoutAlign="start center" fxLayoutGap="8px">
                        <mat-icon>whatsapp</mat-icon>
                        <span>{{ recipient.whatsAppNumber }}</span>
                    </div>
                </div>
                <div class="selection-indicator">
                    <mat-icon
                        *ngIf="isSelected(recipient.id)">check_circle</mat-icon>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="info-box" *ngIf="selectedRecipients.length > 0" fxLayout="row"
        fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-icon>info</mat-icon>
        <span>Você enviará {{ selectedRecipients.length }} {{
            selectedRecipients.length === 1 ? 'mensagem' : 'mensagens' }}
            {{ selectedRecipients.length === 1 ? 'individual' : 'separadas' }},
            uma para cada destinatário selecionado.</span>
    </div>

    <div class="warning-box" *ngIf="data.recipients.length === 0" fxLayout="row"
        fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-icon>warning</mat-icon>
        <span>Nenhum destinatário com número de telefone cadastrado foi
            encontrado. Por favor, adicione números de telefone aos signatários
            do contrato.</span>
    </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-raised-button
        color="primary"
        [disabled]="selectedRecipients.length === 0"
        (click)="confirm()">
        <mat-icon>send</mat-icon>
        Enviar {{ selectedRecipients.length > 0 ? '(' +
        selectedRecipients.length + ')' : '' }}
    </button>
</div>
